module.exports = __webpack_public_path__ + "img/nebula-map.2e404fc.webp";